import Component from '../inherited/Component'

 export default class ProductItem extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._labels = this._elem.querySelectorAll('.ProductItem__Label_Variant')
        this._swatches = document.querySelectorAll('.ColorSwatch__Radio')
    }

    mount () {
        this._showBadge();
    }

    _showBadge() {
        const labels = [...this._labels];
        this._swatches.forEach(element => {
            element.addEventListener('change', function()  {
              const swatchValue = this.value.toUpperCase();
              const labelSelected = labels.find(label => label.getAttribute('data-variant-option') === swatchValue)
              labels.forEach(slider => {
                slider.classList.add('hide');
              });
              if (labelSelected) {
                labelSelected.classList.remove('hide');
              }
            });
          });
    }
    
}